<template>
	<div class="status-box">
	
		<div class="status-box__section">
			<h3 class="status-box__title">Route Color</h3>
			
			<div id="colorbox" :style="{ 'background-color': colorHex }" >
				{{ colorText }} 
			</div>
			
		</div>
		
		<div class="status-box__section">
			<h3 class="status-box__title">Current Status</h3>
			<p class="status-box__text" >
				{{ status }}
			</p>
		</div>
		<div class="status-box__section">
			<h3 class="status-box__title">Thumbnail(s)</h3>
			<img
				class="status-box__thumbnail"
				:src=statusImg
				alt=""
			/>
		</div>
		
	
	<b-modal id="bv-modal-pillow-fill" hide-footer>
		<template #modal-title>
			Remember pillow fillings!
		</template>
		<div class="d-block text-center">
			<h3>Please remember to put the pillow fillings...</h3>
		</div>
		<b-button class="mt-3" block @click="$bvModal.hide('bv-modal-pillow-fill')">OK</b-button>
	</b-modal>
		
		
	</div>
</template>

<script>
import Vue from "vue";

import { mapActions } from "vuex";
import { BModal, BForm, BButton } from 'bootstrap-vue';

Vue.component("b-modal", BModal);
Vue.component("b-button", BButton);

export default Vue.extend({
	name: "",
	data() {
		return {
			//status: ""
			
		};
	},
	components: {},
	methods: {
		...mapActions(["getData"])
	},
	computed: {
		status: {
			get() {
				return this.$store.getters.scanStatus;
			}
		},
		statusImg: {
			get() {
				return this.$store.getters.scanStatusImg;
			}
		},
		colorHex: {
			get() {
				return this.$store.getters.colorHex;
			}
		},
		colorText: {
			get() {
				return this.$store.getters.colorText;
			}
		},
		
		popupData: {
			get() {
				return this.$store.getters.popupData;
			}
		},
	},
	watch: {
		popupData: function (val) {
			this.$refs['bv-modal-pillow-fill'].show()
		},
		
	},	
	mounted() {
		this.getData();
	}
});
</script>

<style lang="scss" scoped>
.status-box {
	&__title {
		border-top-left-radius: 5px;
		border-top-right-radius: 5px;
		margin-bottom: 10px;
		text-align: center;
		font-weight: 600;
		font-size: 16px;
	}

	&__text {
		margin-bottom: 15px;
		text-align: center;
	}

	&__thumbnail {
		border: 1px solid $border-color;
		max-height: 315px;
		margin: 0 auto;
		display: block;
		width: auto;
	}
}

#colorbox {
	color: white;
	text-align: center;
	font-size: 28px;
	
}
</style>